module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/venue-img-three-710342b39bf6a90bc01dfdcb62f0f4c8.jpg";